"use client";

import {
  FilterBar,
  useDefaultOwnedByMe,
  useEmitZapSearchInteractionEvent,
  useLegacyParameterMigration,
  ZapSearchInteractionOptions,
} from "@zapier/shared";
import { useZapFilterConfig } from "./useZapFilterConfig";

interface Props {
  isDisabled?: boolean;
  showFiltersButton?: boolean;
}

export function ZapFilterBar({ isDisabled, showFiltersButton }: Props) {
  const {
    filters,
    quickFilters,
    quickFilterContext,
    stateChips,
    exclusiveMode,
    onFilterInteraction,
    legacyMigrate,
    hasActiveFilters,
    search,
  } = useZapFilterConfig();
  const { emit } = useEmitZapSearchInteractionEvent();

  // useLegacyFilterMigration handled dynamic owner->owners URL upgrades; same here.
  const { hasLegacyParameters } = useLegacyParameterMigration({
    migrate: legacyMigrate,
  });
  useDefaultOwnedByMe({
    hasActiveFilters: hasActiveFilters || !!search || hasLegacyParameters,
  });

  return (
    <FilterBar
      namespace="zap-filter-bar"
      filters={filters}
      quickFilters={quickFilters}
      quickFilterContext={quickFilterContext}
      stateChips={stateChips}
      exclusiveMode={exclusiveMode}
      isDisabled={isDisabled}
      showFiltersButton={showFiltersButton}
      onFilterInteraction={onFilterInteraction}
      onSearch={(value) => {
        if (value.trim().length > 0) {
          emit({ optionSelected: ZapSearchInteractionOptions.Keyword });
        }
      }}
    />
  );
}
